// eslint-disable-next-line import/no-cycle
import store from '@/store';
import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const filesApi = axios.create({
  baseURL: '/files-api', // Use relative path for files service

  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: set the token dynamically
filesApi.interceptors.request.use(
  (config) => {
    const token = (store && store.state && store.state.auth && store.state.auth.token)
    || localStorage.getItem('jwt');

    // Create a new config object to avoid directly mutating the parameter
    const newConfig = { ...config, headers: { ...config.headers } };

    if (token) {
      // Files service expects Bearer tokens
      const tokenValue = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      newConfig.headers.Authorization = tokenValue;
    }

    // Remove Content-Type header for FormData (browser will set it with boundary)
    if (config.data instanceof FormData) {
      delete newConfig.headers['Content-Type'];
    }

    return newConfig;
  },
  (error) => Promise.reject(error),
);

filesApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Lazy import router to avoid circular dependency
      const { default: router } = await import('@/router');
      if (router.currentRoute.value.name !== 'login') {
        router.push('/auth');
      }
    }
    return Promise.reject(error);
  },
);
